import {Timeline, TimelineLite, TweenLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../../server/data/TombOfAkhenatenParsedInitData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAGameEvent} from "../../events/TOAGameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {TombOfAkhenatenGameMode} from "../../gameMode/TombOfAkhenatenGameMode";
import {TOATimelineReelsController} from "../../reel/TOATimelineReelsController";
import {TombOfAkhenaten} from "../../TombOfAkhenaten";
import {SpinStart} from "./SpinStart";

export class SpinStop implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;

    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public getAnimation(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): Timeline | null {
        if(SpinStart.isFullStickyReel){
            return null;
        }
        let stickyReels: number[] = [];
        if (data.mode === TombOfAkhenatenGameMode.NORMAL || data.mode === TombOfAkhenatenGameMode.FREESPIN) {
            stickyReels = [0, 1, 5, 6, 10, 11, 15, 16, 20, 21];
        } else if (data.mode.indexOf("FIRST") > -1) {
            stickyReels = [0, 2, 3, 4, 5, 7, 8, 9, 10, 12, 13, 14, 15, 17, 18, 19, 20, 22, 23, 24];
        } else if (data.mode.indexOf("SECOND") > -1) {
            stickyReels = [1, 2, 3, 4, 6, 7, 8, 9, 11, 12, 13, 14, 16, 17, 18, 19, 21, 22, 23, 24];
        } else {
            let stickySymbols: string[] = (data.stickySymbols).reduce(function (prev, next) {
                return prev.concat(next);
            });

            for (let i: number = 0; i < stickySymbols.length; i++) {
                if (stickySymbols[i] !== "X") {
                    stickyReels.push(i);
                }
            }
        }

        for (let i: number = 0; i < stickyReels.length; i++) {
            !(<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController)._isFinalReSpin && EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_STOP_PRESENTATIONS_COMPLETE, stickyReels[i]));
        }
        const tl: TimelineLite = new TimelineLite();
        //delay added if last column have pyramid expanding wild animation.
        if(data instanceof TombOfAkhenatenParsedGameData && data.pyramidReelLand[data.pyramidReelLand.length-1]){
            const lastReelPyramidReelId = (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).lastPyramidReelIdArr[data.pyramidReelLand.length-1]
            const duration : number = ((lastReelPyramidReelId%5) + 1) * 0.5;
            tl.add(TweenLite.to({}, duration,{}));
        }
        tl.add(() => {
            //do nothing or add delay if required.
        });

        return tl;
    }

    public abort(isActive: boolean, data: ParsedServerData): Timeline | null {
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_SPIN_ABORT));
        return null;
    }
}